module.exports = __webpack_public_path__ + "img/seg2.c5b06386.svg";